import React from "react";
import { ButtonGroup, Dropdown } from "react-bootstrap";
import { useIntl } from "react-intl";
import { AEButton } from "../../../../_emywork/components/buttons";
import { AESVG } from "../../../../_emywork/components/svg";

const Sort = ({ setSortAsc, sort, setSort, sorts }) => {
  const { formatMessage } = useIntl();
  return (
    <Dropdown as={ButtonGroup}>
      <AEButton
        variant={"light"}
        fontWeight={"bolder"}
        onClick={() => {
          setSortAsc(!sort.asc);
        }}
      >
        <AESVG
          path={`/Navigation/${sort.asc ? "Up" : "Down"}-2.svg`}
          variant={"primary"}
        />
        {formatMessage({
          id:
            sorts.findIndex((o) => o.prop === sort.field) !== -1
              ? sorts.find((o) => o.prop === sort.field).label
              : "SORT",
        })}
      </AEButton>
      <Dropdown.Toggle split variant="light-primary" />
      <Dropdown.Menu className={"py-5"}>
        {sorts.map((o) => (
          <Dropdown.Item
            key={o.prop}
            onClick={() => {
              setSort(o.prop, o.asc);
            }}
          >
            {formatMessage({ id: o.label }, { asc: o.asc })}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default Sort;
